<template>
<div id="consulta_adjuntos_pedimentos">

    <v-container grid-list-md text-xs-center>
        <v-flex xs12>
              <v-card>

                <v-card-title> <span class="headline2">{{'Manifestación de Valor - ' + this.$local_storage.get('nombre_manifestacion')}}</span> </v-card-title>
               
                <v-card-text>
                    <v-tabs grow style="margin-bottom: 30px">
                        <v-tabs-slider color="primary"></v-tabs-slider>
                        <v-tab :key="'t1'">Solicitante</v-tab>
                        <v-tab :key="'t2'">Datos de la Manifestación</v-tab>
                        <v-tab :key="'t3'">Información COVE</v-tab>
                        <v-tab :key="'t4'">Documentos</v-tab>
                        <v-tab-item :key="'t1'">
                            <v-card class="elevation-1 px-5 py-3">
                                <v-card-text>
                                    <v-card-title> <span class="headline2">Datos Generales del Solicitante</span> </v-card-title>
                                    <span>Información de la persona física o moral que transmite la Manifestación de Valor</span>
                                    <v-container grid-list-md text-xs-center>
                                        <v-client-table id="oculta_resumen" :data="[{'rfc':model.datosComplementarios.importador.rfc,'razon':model.datosComplementarios.importador.razon_social}]" 
                                            :columns="['rfc','razon']" :options="{filterable:false, headings:{'rfc':'RFC','razon':'Denominación o Razón Social'}}"> <template slot="noResults">
                                            <v-alert :value="true" icon="info" color="info"> No se encontro ningun registro</v-alert>
                                        </template> </v-client-table>                                                                             
                                    </v-container>
                                    <v-container grid-list-md text-xs-center>
                                        <v-client-table id="oculta_resumen" :data="[{'rfc':model.rfc_representante,'razon':model.nombre_representante}]" 
                                            :columns="['rfc','razon']" :options="{filterable:false, headings:{'rfc':'RFC','razon':'Nombre del Representante Legal'}}"> <template slot="noResults">
                                            <v-alert :value="true" icon="info" color="info"> No se encontro ningun registro</v-alert>
                                        </template> </v-client-table>                                                                             
                                    </v-container>
                                    
                                    <v-text>
                                        <strong>Empresa:</strong> {{ model.data_certificado.empresa }} <br>
                                        &nbsp;&nbsp;&nbsp;&nbsp;<strong>País o Región:</strong> {{ model.data_certificado.pais }} <br>
                                        &nbsp;&nbsp;&nbsp;&nbsp;<strong>Dirección de correo:</strong> {{ model.data_certificado.email }} <br>
                                        &nbsp;&nbsp;&nbsp;&nbsp;<strong>Identificador Único:</strong> {{ model.data_certificado.identificador }} <br>
                                        &nbsp;&nbsp;&nbsp;&nbsp;<strong>Número de Serie:</strong> {{ model.data_certificado.serie }} <br>
                                    </v-text>
                                    <v-text>
                                        <br>Nombre del Emisor<br>
                                        &nbsp;&nbsp;&nbsp;&nbsp;<strong>Nombre común:</strong> Autoridad Certificadora <br>
                                        &nbsp;&nbsp;&nbsp;&nbsp;<strong>No válido antes de:</strong> {{ get_fecha_larga(model.data_certificado.fecha_inicio) }} <br>
                                        &nbsp;&nbsp;&nbsp;&nbsp;<strong>No válido después de:</strong> {{ get_fecha_larga(model.data_certificado.fecha_fin) }} <br>
                                    </v-text>                              
                                    
                                </v-card-text>
                            </v-card>                      
                        </v-tab-item>
                        <v-tab-item :key="'t2'">
                            <v-card class="elevation-1 px-5 py-3">
                                <v-card-text>
                                   <!--  <v-card-title> <span class="headline2">Datos de la Manifestación</span> </v-card-title> -->
                                    <v-container grid-list-md text-xs-center>
                                        <v-client-table id="oculta_resumen" :data="[{'rfc':model.datosComplementarios.importador.rfc,'razon':model.datosComplementarios.importador.razon_social,'email':''}]" 
                                            :columns="['rfc','razon','email']" :options="{filterable:false, headings:{'rfc':'RFC del Importador','razon':'Nombre o Razón Social','email':'Correo Electrónico'}}"> <template slot="noResults">
                                            <v-alert :value="true" icon="info" color="info"> No se encontro ningun registro</v-alert>
                                        </template> </v-client-table>                                                                             
                                    </v-container>                                    
                                        <v-container grid-list-md text-xs-center>
                                            <v-client-table id="oculta_resumen" :data="model.datosComplementarios.personaConsulta" :columns="columns_rfcs" :options="options_rfcs"> <template slot="noResults">
                                                    <v-alert :value="true" icon="info" color="info"> No se encontro ningun registro</v-alert>
                                                </template> </v-client-table>
                                        </v-container>
                                                                            
                                    <v-card-title> <span class="headline2">Emisor - Proveedor</span> </v-card-title>
                                    <v-container grid-list-md text-xs-center>
                                        <v-client-table id="oculta_resumen" :data="model.proveedores" :columns="columns_proveedores" :options="options_proveedores">
                                            <template slot="noResults">
                                                <v-alert :value="true" icon="info" color="info"> No se encontro ningun registro</v-alert>
                                            </template>
                                            <template slot="existeVinculacion" slot-scope="props">
                                                {{ props.row.existeVinculacion==1?'SI':'NO' }}
                                            </template>                                                                                        
                                        </v-client-table>                                        
                                    </v-container>

                                    <v-card-title> <span class="headline2">Valor en Aduana</span> </v-card-title>
                                   
                                    <v-container grid-list-md text-xs-center>
                                        <br/>
                                        <v-row  > 
                                            <v-col sm="12" md="6" lg="4" class="pa-5">
                                                <v-text-field  outlined label="Importe total del precio pagado ( M N )" readonly  v-model="model.datosManifestacionValor.valorEnAduana.totalPrecioPagado"></v-text-field>
                                            </v-col>
                                            <v-col sm="12" md="6" lg="4" class="pa-5 text-center">
                                                <v-text-field  outlined label="Importe total del precio por pagar ( M N )" readonly type="text" v-model="model.datosManifestacionValor.valorEnAduana.totalPrecioPorPagar"></v-text-field>
                                            </v-col>
                                        
                                            <v-col sm="12" md="6" lg="4" class="pa-5 text-center">
                                                <v-text-field outlined label="Importe total de incrementables ( M N )" readonly type="text" v-model="model.datosManifestacionValor.valorEnAduana.totalIncrementables"></v-text-field>
                                            </v-col>
                                            </v-row>
                                        <v-row >
                                            <v-col sm="12" md="4" lg="4" class="pa-5 text-center">
                                                <v-text-field outlined label="Importe total de decrementables ( M N )" readonly type="text" v-model="model.datosManifestacionValor.valorEnAduana.totalDecrementables"></v-text-field>
                                            </v-col>
                                      
                                            <v-col sm="12" md="4" lg="4" class="pa-5 text-center">
                                                <v-text-field outlined label="Total del valor en aduana ( M N )" readonly type="text" v-model="model.datosManifestacionValor.valorEnAduana.totalValorAduana"></v-text-field>
                                            </v-col>
                                            <v-col sm="12" md="4" lg="4">
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                            </v-card>                            
                            
                        </v-tab-item>
                        <v-tab-item :key="'t3'">
                            <v-card class="elevation-1 px-5 py-3">
                                <v-card-text>
                                  <!--   <v-card-title> <span class="headline2">Información del COVE </span> </v-card-title> -->
                                    <v-container grid-list-md text-xs-center>
                                        <v-client-table id="oculta_resumen" ref="vuetable_rfcs" :data="model.datosComplementarios.informacionCove" :columns="columns_coves" :options="options_coves">
                                            <template slot="noResults">
                                                <v-alert :value="true" icon="info" color="info"> No se encontro ningun registro</v-alert>
                                            </template>
                                            <template slot="fechaExpedicion" slot-scope="props">
                                               {{parseDate(props.row.fechaExpedicion)}}
                                            </template>
                                            <template slot="existeVinculacion" slot-scope="props">
                                               {{props.row.existeVinculacion==1?"SI":"NO"}}
                                            </template>
                                            <template slot="valorDolares" slot-scope="props">
                                               <div style="text-align:right;">{{formatNumber(props.row.valorDolares,2)}}</div>
                                            </template>
                                            <template slot="actions" slot-scope="props">
                                           <!--      <v-btn fab  x-small color="success" title="Consultar" @click="consulta_cove(props.row.cove);">
                                                    <v-icon dark>search</v-icon>
                                                </v-btn> -->
                                                <v-btn fab x-small color="primary" title="PDF" @click="downloadFile('coves_manifestacion/' + props.row.cove)">
                                                    <v-icon dark>mdi-file</v-icon>
                                                </v-btn>
                                            </template>
                                        </v-client-table>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                            <span v-if="cove_sel == 'NO'"  class="headline2 red--text">NO SE ENCONTRO INFORMACIÓN DEL COVE. <b></b></span>
                            <v-card v-if="model.data_acuse!=null && cove_sel != 'NO' && cove_sel != ''" class="elevation-2 px-5 py-5">

                                    <v-card-text>
                                        <span  class="headline2" >Información Acuse de Valor</span><br>                                        
                                            <v-client-table id="oculta_resumen" :data="model.data_acuse.detalle_coves" 
                                            :columns="['cove','metodoValoracion','incoterm','existeVinculacion','pedimento']" 
                                            :options="{perPage:100, filterable: false, headings: {'cove':'Número de COVE','metodoValoracion':'Método de valoración aduanera','incoterm':'INCOTERM','existeVinculacion':'¿Existe vinculación entre importador y vendedor/proveedor?'}}">
                                                <template slot="pedimento" slot-scope="props">
                                                    <span v-for="pedimento in props.row.pedimento">{{pedimento.pedimento}} | {{pedimento.patente}} | {{pedimento.aduana}}</span>
                                                </template>
                                                
                                            </v-client-table>                                                                                 
                                    
                                        
                                        <span  class="headline2" >Precio pagado</span>                                        
                                        <v-client-table id="oculta_resumen" v-if="model.data_acuse.preciopagado_contador > 0"  ref="vuetable_detalle_coves" :data="model.data_acuse.detalle_preciopagado" 
                                            :columns="['cove','fechaPago','total','tipoPago','especifique','tipoMoneda','tipoCambio']" 
                                            :options="{perPage:100, filterable: false, headings: {'cove':'Número de COVE','fechaPago':'Fecha de pago','total':'Importe',
                                                'tipoPago':'Forma de pago','tipoMoneda':'Tipo de moneda','tipoCambio':'Tipo de cambio'}}">
                                                <template slot="fechaPago" slot-scope="props">
                                                    {{ parseDate(props.row.fechaPago) }}
                                                </template>
                                                <template slot="total" slot-scope="props">
                                                    <div style="text-align:right;"> {{ formatNumber(props.row.total,3) }}</div>
                                                </template>
                                                <template slot="tipoCambio" slot-scope="props">
                                                    <div style="text-align:right;"> {{ formatNumber(props.row.tipoCambio,3) }} </div>
                                                </template>                                            
                                        </v-client-table>                                        
                                        <template v-else-if="model.data_acuse.preciopagado_contador == 0">
                                            <br><span>N / A</span><br><br>
                                        </template>

                                        
                                        
                                        <span  class="headline2" >Precio por pagar</span>                                        
                                        <v-client-table id="oculta_resumen" v-if="model.data_acuse.porpagar_contador > 0"  ref="vuetable_detalle_coves" :data="model.data_acuse.detalle_porpagar" 
                                            :columns="['cove','fechaPago','total','situacionNofechaPago','tipoPago','especifique','tipoMoneda','tipoCambio']" 
                                            :options="{perPage:100, filterable: false, headings: {'cove':'Número de COVE','fechaPago':'Fecha de pago','total':'Importe',
                                                'situacionNofechaPago':'Momento(s) o situacion(es) cuando se realizará el pago',
                                                'tipoPago':'Forma de pago','tipoMoneda':'Tipo de moneda','tipoCambio':'Tipo de cambio'}}">
                                                <template slot="fechaPago" slot-scope="props">
                                                    {{ parseDate(props.row.fechaPago) }}
                                                </template>
                                                <template slot="total" slot-scope="props">
                                                    <div style="text-align:right;"> {{ formatNumber(props.row.total,3) }}</div>
                                                </template>
                                                <template slot="tipoCambio" slot-scope="props">
                                                    <div style="text-align:right;"> {{ formatNumber(props.row.tipoCambio,3) }} </div>
                                                </template>                                            
                                        </v-client-table>                                        
                                        <template v-else-if="model.data_acuse.porpagar_contador == 0">
                                            <br><span>N / A</span><br><br>
                                        </template>
                                        
                                        
                                        <span  class="headline2" >Compenso pago</span>                                        
                                        <v-client-table id="oculta_resumen" v-if="model.data_acuse.compensopago_contador > 0"  ref="vuetable_detalle_coves" :data="model.data_acuse.detalle_compensopago" 
                                            :columns="['cove','fecha','motivo','prestacionMercancia','tipoPago','especifique']" 
                                            :options="{perPage:100, filterable: false, headings: {'cove':'Número de COVE','fecha':'Fecha de pago','motivo':'Motivo por lo que se realizó',
                                                'prestacionMercancia':'Prestación de la mercancía',
                                                'tipoPago':'Forma de pago'}}">
                                                <template slot="fecha" slot-scope="props">
                                                    {{ parseDate(props.row.fecha) }}
                                                </template>                                                
                                        </v-client-table>                                        
                                        <template v-else-if="model.data_acuse.compensopago_contador == 0">
                                            <br><span>N / A</span><br><br>
                                        </template>
                                        
                                        <div class="d-flex align-center">
                                            <span class="headline2">
                                                Incrementables conforme al artículo 65 de la ley
                                            </span>
                                            &nbsp;&nbsp;

                                            <exportar-excel v-show="datos_incrementables.length>0"
                                                :data="datos_incrementables"
                                                :exportFields="camposExcelIncrementables"
                                                :name="this.$local_storage.get('nombre_manifestacion')+'_Incrementables.xlsx'"
                                            >
                                                <v-btn fab dark x-small color="green darken-4" title="Exportar Incrementables" v-tippy>
                                                    <v-icon dark>mdi-table</v-icon>
                                                </v-btn>
                                            </exportar-excel>
                                        </div>
                                        
                                        
                                        <template v-if="model.data_acuse.incrementables_contador > 0">
                                            <p>A cargo del importador y no estén incluidos en el precio pagado por las mercancías</p>                                            
                                            <template v-if="model.data_acuse.incrementables.CG.length">
                                                <br>
                                                <span>Comisiones y gastos de corretaje, excepto comisiones de compra.</span><br>
                                                <v-client-table id="oculta_resumen" :data="model.data_acuse.incrementables.CG" :columns="columns_incre" :options="options_incre">
                                                        <template slot="fechaErogacion" slot-scope="props">
                                                            {{ parseDate(props.row.fechaErogacion) }}
                                                        </template> 
                                                        <template slot="aCargoImportador" slot-scope="props">
                                                            {{ props.row.aCargoImportador == 1 ? 'Si':'No' }}
                                                        </template>  
                                                        <template slot="importe" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.importe,3) }}</div>
                                                    </template>
                                                    <template slot="tipoCambio" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.tipoCambio,3) }} </div>
                                                    </template>                                                                                          
                                                </v-client-table>                                            
                                            </template>
                                            <template v-if="model.data_acuse.incrementables.CE.length">
                                                <br>
                                                <span>Costo de los envases o embalajes que formen un todo con las mercancías.</span><br>
                                                <v-client-table id="oculta_resumen" :data="model.data_acuse.incrementables.CE" :columns="columns_incre" :options="options_incre">
                                                        <template slot="fechaErogacion" slot-scope="props">
                                                            {{ parseDate(props.row.fechaErogacion) }}
                                                        </template> 
                                                        <template slot="aCargoImportador" slot-scope="props">
                                                            {{ props.row.aCargoImportador == 1 ? 'Si':'No' }}
                                                        </template>  
                                                        <template slot="importe" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.importe,3) }}</div>
                                                    </template>
                                                    <template slot="tipoCambio" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.tipoCambio,3) }} </div>
                                                    </template>                                                                                          
                                                </v-client-table>                                            
                                            </template>
                                            <template v-if="model.data_acuse.incrementables.GT.length">
                                                <br>
                                                <span>Gastos de embalaje (mano de obra y/o materiales)</span><br>
                                                <v-client-table id="oculta_resumen" :data="model.data_acuse.incrementables.GT" :columns="columns_incre" :options="options_incre">
                                                        <template slot="fechaErogacion" slot-scope="props">
                                                            {{ parseDate(props.row.fechaErogacion) }}
                                                        </template> 
                                                        <template slot="aCargoImportador" slot-scope="props">
                                                            {{ props.row.aCargoImportador == 1 ? 'Si':'No' }}
                                                        </template>  
                                                        <template slot="importe" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.importe,3) }}</div>
                                                    </template>
                                                    <template slot="tipoCambio" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.tipoCambio,3) }} </div>
                                                    </template>                                                                                          
                                                </v-client-table>                                            
                                            </template>
                                            <template v-if="model.data_acuse.incrementables.GS.length">
                                                <br>
                                                <span>Gastos de transporte, seguros y conexos (como manejo, carga y descarga) erogados antes de los momentos señalados en el artículo 56 fracción I de la Ley.</span><br>
                                                <v-client-table id="oculta_resumen" :data="model.data_acuse.incrementables.GS" :columns="columns_incre" :options="options_incre">
                                                        <template slot="fechaErogacion" slot-scope="props">
                                                            {{ parseDate(props.row.fechaErogacion) }}
                                                        </template> 
                                                        <template slot="aCargoImportador" slot-scope="props">
                                                            {{ props.row.aCargoImportador == 1 ? 'Si':'No' }}
                                                        </template>  
                                                        <template slot="importe" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.importe,3) }}</div>
                                                    </template>
                                                    <template slot="tipoCambio" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.tipoCambio,3) }} </div>
                                                    </template>                                                                                          
                                                </v-client-table>                                            
                                            </template>
                                            <template v-if="model.data_acuse.incrementables.MP.length || model.data_acuse.incrementables.HM.length || model.data_acuse.incrementables.MC.length || model.data_acuse.incrementables.TI.length || model.data_acuse.incrementables.RD.length || model.data_acuse.incrementables.VC.length">
                                                <br>
                                                    <span style="font-size:1.2rem;">El valor de los bienes y servicios que no estén incluidos en el precio pagado y hayan sido proporcionado por el importador en la producción y venta para exportar las mercancías</span>
                                                <br>
                                            </template>
                                            <template v-if="model.data_acuse.incrementables.MP.length">
                                                <br>
                                                <span>Materiales, piezas y elementos, partes y artículos análogos incorporados a las mercancías importadas.</span><br>
                                                <v-client-table id="oculta_resumen" :data="model.data_acuse.incrementables.MP" :columns="columns_incre" :options="options_incre">
                                                        <template slot="fechaErogacion" slot-scope="props">
                                                            {{ parseDate(props.row.fechaErogacion) }}
                                                        </template> 
                                                        <template slot="aCargoImportador" slot-scope="props">
                                                            {{ props.row.aCargoImportador == 1 ? 'Si':'No' }}
                                                        </template>  
                                                        <template slot="importe" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.importe,3) }}</div>
                                                    </template>
                                                    <template slot="tipoCambio" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.tipoCambio,3) }} </div>
                                                    </template>                                                                                          
                                                </v-client-table>                                            
                                            </template>
                                            <template v-if="model.data_acuse.incrementables.HM.length">
                                                <br>
                                                <span>Herramientas, matrices, moldes y elementos análogos utilizados para la producción de las mercancías importadas.</span><br>
                                                <v-client-table id="oculta_resumen" :data="model.data_acuse.incrementables.HM" :columns="columns_incre" :options="options_incre">
                                                        <template slot="fechaErogacion" slot-scope="props">
                                                            {{ parseDate(props.row.fechaErogacion) }}
                                                        </template> 
                                                        <template slot="aCargoImportador" slot-scope="props">
                                                            {{ props.row.aCargoImportador == 1 ? 'Si':'No' }}
                                                        </template>  
                                                        <template slot="importe" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.importe,3) }}</div>
                                                    </template>
                                                    <template slot="tipoCambio" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.tipoCambio,3) }} </div>
                                                    </template>                                                                                          
                                                </v-client-table>                                            
                                            </template>
                                            <template v-if="model.data_acuse.incrementables.MC.length">
                                                <br>
                                                <span>Materiales consumidos en la producción de las mercancías importadas.</span><br>
                                                <v-client-table id="oculta_resumen" :data="model.data_acuse.incrementables.MC" :columns="columns_incre" :options="options_incre">
                                                        <template slot="fechaErogacion" slot-scope="props">
                                                            {{ parseDate(props.row.fechaErogacion) }}
                                                        </template> 
                                                        <template slot="aCargoImportador" slot-scope="props">
                                                            {{ props.row.aCargoImportador == 1 ? 'Si':'No' }}
                                                        </template>  
                                                        <template slot="importe" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.importe,3) }}</div>
                                                    </template>
                                                    <template slot="tipoCambio" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.tipoCambio,3) }} </div>
                                                    </template>                                                                                          
                                                </v-client-table>                                            
                                            </template>
                                            <template v-if="model.data_acuse.incrementables.TI.length">
                                                <br>
                                                <span>Trabajos de ingeniería, creación y perfeccionamiento, artísticos, diseños, planos y croquis realizados fuera del territorio nacional que sean necesarios para la producción de las mercancías importadas.</span><br>
                                                <v-client-table id="oculta_resumen" :data="model.data_acuse.incrementables.TI" :columns="columns_incre" :options="options_incre">
                                                        <template slot="fechaErogacion" slot-scope="props">
                                                            {{ parseDate(props.row.fechaErogacion) }}
                                                        </template> 
                                                        <template slot="aCargoImportador" slot-scope="props">
                                                            {{ props.row.aCargoImportador == 1 ? 'Si':'No' }}
                                                        </template>  
                                                        <template slot="importe" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.importe,3) }}</div>
                                                    </template>
                                                    <template slot="tipoCambio" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.tipoCambio,3) }} </div>
                                                    </template>                                                                                          
                                                </v-client-table>                                            
                                            </template>
                                            <template v-if="model.data_acuse.incrementables.RD.length">
                                                <br>
                                                <span>Las regalías y derechos de licencia a pagar como condición de la venta de las mercancías a importar, que no estén incluidos en el precio pagado.</span><br>
                                                <v-client-table id="oculta_resumen" :data="model.data_acuse.incrementables.RD" :columns="columns_incre" :options="options_incre">
                                                        <template slot="fechaErogacion" slot-scope="props">
                                                            {{ parseDate(props.row.fechaErogacion) }}
                                                        </template> 
                                                        <template slot="aCargoImportador" slot-scope="props">
                                                            {{ props.row.aCargoImportador == 1 ? 'Si':'No' }}
                                                        </template>  
                                                        <template slot="importe" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.importe,3) }}</div>
                                                    </template>
                                                    <template slot="tipoCambio" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.tipoCambio,3) }} </div>
                                                    </template>                                                                                          
                                                </v-client-table>                                            
                                            </template>
                                            <template v-if="model.data_acuse.incrementables.VC.length">
                                                <br>
                                                <span>Valor de cualquier parte del producto de la enajenación, cesión o utilización, posteriores a la importación, que se revierta directa o indirectamente al vendedor.</span><br>
                                                <v-client-table id="oculta_resumen" :data="model.data_acuse.incrementables.VC" :columns="columns_incre" :options="options_incre">
                                                        <template slot="fechaErogacion" slot-scope="props">
                                                            {{ parseDate(props.row.fechaErogacion) }}
                                                        </template> 
                                                        <template slot="aCargoImportador" slot-scope="props">
                                                            {{ props.row.aCargoImportador == 1 ? 'Si':'No' }}
                                                        </template>  
                                                        <template slot="importe" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.importe,3) }}</div>
                                                    </template>
                                                    <template slot="tipoCambio" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.tipoCambio,3) }} </div>
                                                    </template>                                                                                          
                                                </v-client-table>                                            
                                            </template>
                                        </template>
                                        <template v-else-if="model.data_acuse.incrementables_contador == 0">
                                            <br><span>N / A</span><br></br>
                                        </template>

                                        <br>                                            
                                            <div class="d-flex align-center">
                                            <span  class="headline2" >Información que no integra el valor de transacción conforme el artículo 66 de la ley aduanera (DECREMENTABLES)(Se considera que se distinguen del precio pagado las cantidades que se mencionan, se detallan o especifican separadamente del precio pagado en el comprobante fiscal digital o en el documento equivalente)</span>
                                            &nbsp;&nbsp;

                                            <exportar-excel v-show="datos_decrementables.length>0"
                                                :data="datos_decrementables"
                                                :exportFields="camposExcelDecrementables"
                                                :name="this.$local_storage.get('nombre_manifestacion')+'_Decrementables.xlsx'">
                                                <v-btn fab dark x-small color="green darken-4" title="Exportar Decrementables" v-tippy>
                                                    <v-icon dark>mdi-table</v-icon>
                                                </v-btn>
                                            </exportar-excel>
                                        </div>
                                        <br>
                                        <template v-if="model.data_acuse.decrementables_contador > 0">
                                            <template v-if="model.data_acuse.decrementables.GR.length">
                                                <br>
                                                <span>Gastos realizados por cuenta del importador</span><br>
                                                <v-client-table id="oculta_resumen" :data="model.data_acuse.decrementables.GR" :columns="columns_decre" :options="options_decre">
                                                        <template slot="fechaErogacion" slot-scope="props">
                                                            {{ parseDate(props.row.fechaErogacion) }}
                                                        </template> 
                                                        <template slot="importe" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.importe,3) }}</div>
                                                    </template>
                                                    <template slot="tipoCambio" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.tipoCambio,3) }} </div>
                                                    </template>                                                                                          
                                                </v-client-table>                                            
                                            </template>
                                            <template v-if="model.data_acuse.decrementables.GT.length">
                                                <br>
                                                <span>Gastos de transporte, seguros y conexos (como manejo, carga y descarga) erogados con posterioridad a que se den los momentos señalados en el artículo 56 fracción I de la Ley.</span><br>
                                                <v-client-table id="oculta_resumen" :data="model.data_acuse.decrementables.GT" :columns="columns_decre" :options="options_decre">
                                                        <template slot="fechaErogacion" slot-scope="props">
                                                            {{ parseDate(props.row.fechaErogacion) }}
                                                        </template> 
                                                        <template slot="importe" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.importe,3) }}</div>
                                                    </template>
                                                    <template slot="tipoCambio" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.tipoCambio,3) }} </div>
                                                    </template>                                                                                          
                                                </v-client-table>                                            
                                            </template>
                                            <template v-if="model.data_acuse.decrementables.ID.length">
                                                <br>
                                                <span>Información de descuentos especiales para aplicar en el momento de la compraventa</span><br>
                                                <v-client-table id="oculta_resumen" :data="model.data_acuse.decrementables.ID" :columns="columns_decre" :options="options_decre">
                                                        <template slot="fechaErogacion" slot-scope="props">
                                                            {{ parseDate(props.row.fechaErogacion) }}
                                                        </template> 
                                                        <template slot="importe" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.importe,3) }}</div>
                                                    </template>
                                                    <template slot="tipoCambio" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.tipoCambio,3) }} </div>
                                                    </template>                                                                                          
                                                </v-client-table>                                            
                                            </template>
                                            <template v-if="model.data_acuse.decrementables.RP.length || model.data_acuse.decrementables.RC.length || model.data_acuse.decrementables.PI.length">
                                                <span style="font-size:1.2rem;">
                                                    Gastos que se distingan del precio pagado por las mercancías importadas</span>
                                                <br>
                                            </template>
                                            <template v-if="model.data_acuse.decrementables.RP.length">
                                                <br>
                                                <span>Los realizados posteriores a la importación por construcción, instalación, armado, montaje, mantenimiento o asistencia técnica.</span><br>
                                                <v-client-table id="oculta_resumen" :data="model.data_acuse.decrementables.RP" :columns="columns_decre" :options="options_decre">
                                                        <template slot="fechaErogacion" slot-scope="props">
                                                            {{ parseDate(props.row.fechaErogacion) }}
                                                        </template> 
                                                        <template slot="importe" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.importe,3) }}</div>
                                                    </template>
                                                    <template slot="tipoCambio" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.tipoCambio,3) }} </div>
                                                    </template>                                                                                          
                                                </v-client-table>                                            
                                            </template>
                                            <template v-if="model.data_acuse.decrementables.RC.length">
                                                <br>
                                                <span>Los realizados por contribuciones y cuotas compensatorias aplicables en territorio nacional por la importación o enajenación</span><br>
                                                <v-client-table id="oculta_resumen" :data="model.data_acuse.decrementables.RC" :columns="columns_decre" :options="options_decre">
                                                        <template slot="fechaErogacion" slot-scope="props">
                                                            {{ parseDate(props.row.fechaErogacion) }}
                                                        </template> 
                                                        <template slot="importe" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.importe,3) }}</div>
                                                    </template>
                                                    <template slot="tipoCambio" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.tipoCambio,3) }} </div>
                                                    </template>                                                                                          
                                                </v-client-table>                                            
                                            </template>
                                            <template v-if="model.data_acuse.decrementables.PI.length">
                                                <br>
                                                <span>Pagos del importador al vendedor por dividendos u otros que no guarden relación directa con las mercancías importadas.</span><br>
                                                <v-client-table id="oculta_resumen" :data="model.data_acuse.decrementables.PI" :columns="columns_decre" :options="options_decre">
                                                        <template slot="fechaErogacion" slot-scope="props">
                                                            {{ parseDate(props.row.fechaErogacion) }}
                                                        </template> 
                                                        <template slot="importe" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.importe,3) }}</div>
                                                    </template>
                                                    <template slot="tipoCambio" slot-scope="props">
                                                        <div style="text-align:right;"> {{ formatNumber(props.row.tipoCambio,3) }} </div>
                                                    </template>                                                                                          
                                                </v-client-table>                                            
                                            </template>
                                        </template>
                                    
                                    
                                    </v-card-text>

                            </v-card>
                        </v-tab-item>
                        <v-tab-item :key="'t4'">
                            <v-card class="elevation-1 px-5 py-3">
                                <v-card-text>
                                   <!--  <v-card-title> <span class="headline2">Documentos</span> </v-card-title> -->
                                    <v-container grid-list-md text-xs-center>
                                        <v-client-table ref="vuetable_documentos" :data="model.datosComplementarios.documentosDatos" :columns="columns_documentos" :options="options_documentos"> <template slot="noResults">
                                                <v-alert :value="true" icon="info" color="info"> No se encontró ningún registro</v-alert>
                                            </template>
                                             <template slot="tipo" slot-scope="props">
                                                 <div class="columnaTipo" >
                                                    {{getNombreTipo(props.row.tipo)}}
                                                 </div>
                                            </template>
                                            <template slot="actions" slot-scope="props">

                                                <v-btn fab x-small color="primary" title="PDF" @click="downloadFile('edocs_manifestacion/' + props.row.eDocument)" >
                                                    <v-icon dark>mdi-file</v-icon>
                                                </v-btn>
                                            </template>

                                            </v-client-table>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                    </v-tabs>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-container>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
    data: vm => ({
            datos_incrementables: [],
            datos_decrementables: [],
            camposExcelIncrementables: {
                'Número de COVE':'cove', 
                "Tipo Incrementable":'tipoIncrementable',
                "Fecha de erogación":'fechaErogacion',
                "Importe (M.N.)":'importe',
                "¿Esta a cargo del importador?":'aCargoImportador',
                "Tipo de Moneda":'tipoMoneda',
                "Tipo de cambio":'tipoCambio',
                "Concepto Tipo Incrementable":'concepto_tipo_incrementable'
            },
            camposExcelDecrementables: {
                'Número de COVE':'cove', 
                "Tipo Decrementable":'tipoDecrementable',
                "Fecha de erogación":'fechaErogacion',
                "Importe (M.N.)":'importe',
                "Tipo de Moneda":'tipoMoneda',
                "Tipo de cambio":'tipoCambio',
                "Concepto Tipo Incrementable":'concepto_tipo_incrementable'
            },
            columns_incre: ['cove','fechaErogacion','importe','aCargoImportador','tipoMoneda','tipoCambio','concepto_tipo_incrementable'], 
            options_incre:{
                filterable: false, 
                headings: {'cove':'Número de COVE','fechaErogacion':'Fecha de erogación','importe':'Importe (M.N.)',
                'aCargoImportador':'¿Esta a cargo del importador?',
                'tipoMoneda':'Tipo de Moneda','tipoCambio':'Tipo de cambio',
                'concepto_tipo_incrementable':'Concepto Tipo Incrementable'}
            },
            columns_decre: ['cove','fechaErogacion','importe','tipoMoneda','tipoCambio','concepto_tipo_incrementable'], 
            options_decre:{
                filterable: false, 
                headings: {'cove':'Número de COVE','fechaErogacion':'Fecha de erogación','importe':'Importe (M.N.)',
                'tipoMoneda':'Tipo de Moneda','tipoCambio':'Tipo de cambio',
                'concepto_tipo_incrementable':'Concepto Tipo Decrementable'}
            },
            breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home",
            },
            {
                text: "eManifiesto",
                disabled: true,
                to: ""
            },
            {
                text: "Vista Previa",
                disabled: true,
                to: "",
            },
        ],
        cove_sel: "SI",
        datos:"",
        informacionCove: {
                        "cove": "COVE214AFVKJ5",
                        "pedimento": [{
                            "pedimento": "",
                            "patente": "",
                            "aduana": ""
                        }],
                        "precioPagado": [{
                            "fechaPago": "",
                            "total": "",
                            "tipoPago": "",
                            "especifique": ""
                        }],
                        "precioPorPagar": [{
                            "fechaPago": "",
                            "total": "",
                            "situacionNofechaPago": "",
                            "tipoPago": "",
                            "especifique": ""
                        }],
                        "compensoPago": [{
                            "tipoPago": "",
                            "fecha": "2",
                            "motivo": "",
                            "prestacionMercancia": "",
                            "especifique": ""
                        }],
                        "metodoValoracion": "",
                        "incrementables": [{
                            "tipoIncrementable": "",
                            "fechaErogacion": "",
                            "importe": "13",
                            "aCargoImportador": ""
                        }],
                        "decrementables": [{
                            "tipoDecrementable": "",
                            "fechaErogacion": "",
                            "importe": "45"
                        }]
                    },
        model: {
            "id": "",
            "id_padre": "",
            "rfc": "",
            "tipo_manifestacion": "",
            "momento_transmision": "",
            "ejercicion_fiscal": null,
            "rfc_emisor": "",
            "no_pedimento": "",
            "lista_coves": [{
                    cove: ""
                },
            ],
            "fecha_de": null,
            "fecha_a": null,
            "fecha_creado": "",
            "fecha_envio": null,
            "usuario_email": "",
            "enviado_por": null,
            "datosManifestacionValor": {
                "personaConsulta": [{
                        "rfc": ""
                    },
                ],
                "documentos": [{
                        "eDocument": ""
                    },
                ],
                "informacionCove": [ ],
                "valorEnAduana": {
                    "totalPrecioPagado": 0,
                    "totalPrecioPorPagar": 0,
                    "totalIncrementables": 0,
                    "totalDecrementables": 0,
                    "totalValorAduana": 0
                },
                "existeVinculacion": "1"
            },

            "datosComplementarios":{
                "importador":"",
                "proveedor":"",

            },
            "estatus": "0",
            "xml": "0",
            "pdf": "0",
            "acuse": "0",
            "nombre_proceso": "",
            "size": 0,
            "no_operacion": null,
            "error": null,
            "layout_manifestacion": "",
            "layout_coves": null,
            "data_certificado":{"empresa":"","pais":"","email":"","identificador":"","serie":"","fecha_inicio":"","fecha_fin":""}
        },
        modelvacio: {
            "id": "",
            "id_padre": "",
            "rfc": "",
            "tipo_manifestacion": "",
            "momento_transmision": "",
            "ejercicion_fiscal": null,
            "rfc_emisor": "",
            "no_pedimento": "",
            "lista_coves": [{
                    cove: ""
                },
            ],
            "fecha_de": null,
            "fecha_a": null,
            "fecha_creado": "",
            "fecha_envio": null,
            "usuario_email": "",
            "enviado_por": null,
            "datosManifestacionValor": {
                "personaConsulta": [{
                        "rfc": ""
                    },
                ],
                "documentos": [{
                        "eDocument": ""
                    },
                ],
                "informacionCove": [ ],
                "valorEnAduana": {
                    "totalPrecioPagado": 0,
                    "totalPrecioPorPagar": 0,
                    "totalIncrementables": 0,
                    "totalDecrementables": 0,
                    "totalValorAduana": 0
                },
                "existeVinculacion": "1"
            },

            "datosComplementarios":{
                "importador":"",
                "proveedor":"",

            },
            "estatus": "0",
            "xml": "0",
            "pdf": "0",
            "acuse": "0",
            "nombre_proceso": "",
            "size": 0,
            "no_operacion": null,
            "error": null,
            "layout_manifestacion": "",
            "layout_coves": null
        },
        columns_documentos: [
            "eDocument",
            "tipo",
            "nombre_archivo",
            "actions"
        ],
        options_documentos: {
            filterable: false,
            headings: {
                eDocument: "eDocument",
                tipo: "Tipo de Documento",
                "nombre_archivo":"Nombre del Archivo",
                actions: "Opciones"
            },
        },
        columns_rfcs: ["rfc", "razon_social", "tipoFigura"],
        options_rfcs: {
           filterable: false,
            headings: {
                rfc: "RFC de consulta",
                razon_social: "Nombre o Razón Social",
                "tipoFigura":"Tipo de Figura"
            },
        },
        columns_pedimentos: ["pedimento", "patente", "aduana", ],
        options_pedimentos: {
            filterable: false,
            headings: {
                "pedimento": "Pedimento",
                "patente": "Patente",
                "aduana": "Aduana",
            },
        },
        columns_proveedores: ["rfc", "razon_social", "pais", "existeVinculacion"],
        options_proveedores: {
            perPage: 100,
            filterable: false,
            headings: {
                "rfc":"RFC o TAX ID", "razon_social":"Denominación o Razón Social", "pais":"País de Facturación", "existeVinculacion":"Vinculación"
            },
        },
        columns_coves: ["cove", "metodoValoracionNombre", "numeroFacturaRelacionFacturas",
            "fechaExpedicion", "emisor.nombre", "destinatario.nombre", "existeVinculacion", "valorDolares", "actions"],
        options_coves: {
            perPage: 100,
           filterable: false,
            headings: {
                "cove": "COVE",
                "metodoValoracionNombre": "Método Valoración",
                "numeroFacturaRelacionFacturas": "# Factura",
                "fechaExpedicion": "Fecha expedición",
                "emisor.nombre": "Emisor original",
                "destinatario.nombre": "Destinatario",
                "existeVinculacion":"Existe Vinculación?",
                "valorDolares":"Valor en Dolares",
                "actions": "Opciones"
            },
        },
        columns_precio_pagado: ["fechaPago", "total", "tipoPago", "especifique", ],
        options_precio_pagado: {
            filterable: false,
            headings: {
                "fechaPago": "Fecha Pago",
                "total": "Total",
                "tipoPago": "Forma de Pago",
                "especifique": "Especifique",
            },
        },
        columns_precio_x_pagar: ["fechaPago", "total", "tipoPago", "situacionNofechaPago", "especifique", ],
        options_precio_x_pagar: {
            filterable: false,
            headings: {
                "fechaPago": "Fecha Pago",
                "total": "Total",
                "formatipoPago_pago": "Forma de Pago",
                "situacionNofechaPago": "Momento(s) o situacion(es)cuando se realizará el pago",
                "especifique": "Especifique",
            },
        },
        columns_compenso_pago: ["fecha", "motivo", "prestacionMercancia", "tipoPago", "especifique", ],
        options_compenso_pago: {
            filterable: false,
            headings: {
                "fecha": "Fecha Pago",
                "motivo": "Motivo",
                "prestacionMercancia": "Prestación de la Mercancía",
                "tipoPago": "Forma de Pago",
                "especifique": "Especifique",
            },
        },
        tiposDocumentos:[],

    }),
     mounted: function () {
        this.URL = this.$hostname ;
        if(parseInt(this.$local_storage.get('id_manifestacion'))> 0)
        this.cargarTiposDocumentos();
        this.cargar();
    },
    methods: {
        get_fecha_larga:function(date){
            if (!date) return null;
            moment.locale("es");
            // Formatea la fecha
            return moment(date).format("dddd, D [de] MMMM [de] YYYY, h:mm:ss a");
        },
        getNombreTipo: function (val) {
            var filtro = this.tiposDocumentos.filter(e => e.clave == val);
            if(filtro.length>0){
                return filtro[0].clave + " - " + filtro[0].descripcion;
            } else
                return val;

        },
        cargarTiposDocumentos: function () {
            axios
                .post(this.$hostname + "apendices/lista/", {
                    tabla: 25
                })
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.tiposDocumentos = res.data;
                    } else {
                        this.$swal({
                            type: "warning",
                            title: "Aviso",
                            text: "No se han ingresado datos al apéndice de tipos de documentos",
                            footer: ""
                        });
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el apéndice de tipos de documentos.",
                        footer: ""
                    });
                    console.log(err);
                });
        },
        consulta_cove: function (cove) {
            this.cove_sel = cove;
            /*let arreglo = this.model.datosComplementarios.informacionCove;
             var filtro = arreglo.filter(function (e) {
                return e.cove == cove;
            });

            if (filtro.length > 0)
                 this.informacionCove = filtro[0];
            else
                this.cove_sel = "NO";*/

        },
        getIncrementable: function (tipo, campo) {

            let arreglo = this.informacionCove.incrementables;
             var filtro = arreglo.filter(function (e) {
                return e.tipoIncrementable == tipo;
                });
            if (filtro.length > 0){
                if(campo == 'fechaErogacion')
                    return filtro[0][campo].substring(0, 10);
                else
                    return filtro[0][campo];
            }
            else
                return ""
        },
        getDecrementable: function (tipo, campo) {

            let arreglo = this.informacionCove.decrementables;
             var filtro = arreglo.filter(function (e) {
                return e.tipoDecrementable == tipo;
                });
            if (filtro.length > 0){
                if(campo == 'fechaErogacion')
                    return filtro[0][campo].substring(0, 10);
                else
                    return filtro[0][campo];
            }
            else
                return ""
        },
        getMetodo: function (clave) {
            switch (clave) {
                case 'VALADU.A78':
                    return "Valor determinado conforme a lo establecido en el artículo 78";
                    break;
                case 'VALADU.VMI':
                    return "Valor de transacción de las mercancías idénticas";
                    break;
                case 'VALADU.VMS':
                    return "Valor de transacción de las mercancías similares";
                    break;
                case 'VALADU.VPU':
                    return "Valor de precio unitario de venta";
                    break;
                case 'VALADU.VPV':
                    return "Venta entre personas vinculadas";
                    break;
                case 'VALADU.VR':
                    return "Valor reconstruido de las mercancías importadas";
                    break;
                case 'VALADU.VTM':
                    return "Valor de transacción";
                    break;
                default:
                    return "";
            }
        },
        getFormaPago: function (clave) {
            switch (clave) {
                case 'FORPAG.CC':
                    return "Carta de crédito";
                    break;
                case 'FORPAG.CH':
                    return "Cheque";
                    break;
                case 'FORPAG.EF':
                    return "Efectivo";
                    break;
                case 'FORPAG.LC':
                    return "Letra de cambio";
                    break;
                case 'FORPAG.OT':
                    return "Otro tipo de pago";
                    break;
                case 'FORPAG.TE':
                    return "Transferencia electrónica";
                    break;
                default:
                    return "";
                    break;
            }
        },
        formatNumber: function(numero, decimales){
            if (numero == undefined || numero == null || numero == "")
                return ""
            return (numero).toFixed(decimales).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        },
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("DD-MM-YYYY");
        },
        cargar: function () {
            let self = this;
            this.datos_decrementables = [];
            this.datos_incrementables = [];
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

                  let data = {
                id:  parseInt(this.$local_storage.get('id_manifestacion'))
            };
            axios.post(this.URL + "manifestacion/get_detalle_manifestacion/", data)
            //axios.post("http://127.0.0.1:7000/manifestacion/get_detalle_manifestacion/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.model = res.data;
                         if(self.model.datosComplementarios == null )
                                self.model.datosComplementarios = self.modelvacio.datosComplementarios;
                        if(self.model.datosManifestacionValor == null )
                                self.model.datosManifestacionValor = self.modelvacio.datosManifestacionValor;
                        
                        //Obtenemos los incrementables en un solo data
                        try {
                            if(self.model.data_acuse.incrementables){
                                for(var ktipo in self.model.data_acuse.incrementables){
                                    for(var kinc in self.model.data_acuse.incrementables[ktipo]){
                                        self.model.data_acuse.incrementables[ktipo][kinc]['fechaErogacion'] = this.parseDate(self.model.data_acuse.incrementables[ktipo][kinc]['fechaErogacion']);
                                        self.datos_incrementables.push(self.model.data_acuse.incrementables[ktipo][kinc]);                                        
                                    }
                                        
                                }
                            }                               
                        } catch (error) {
                            console.log("Error al procesar data de model.data_acuse.incrementables", error)
                        }

                        //Obtenemos los incrementables en un solo data
                        try {
                            if(self.model.data_acuse.decrementables){
                                for(var ktipo in self.model.data_acuse.decrementables){
                                    for(var kinc in self.model.data_acuse.decrementables[ktipo]){
                                        self.model.data_acuse.decrementables[ktipo][kinc]['fechaErogacion'] = this.parseDate(self.model.data_acuse.decrementables[ktipo][kinc]['fechaErogacion']);
                                        self.datos_decrementables.push(self.model.data_acuse.decrementables[ktipo][kinc]);
                                    }                                        
                                }
                            }    
                            
                        } catch (error) {
                            console.log("Error al procesar data de model.data_acuse.decrementables", error)
                        }
                        
                        
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los registros",
                        footer: ""
                    });
                    console.log(err);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        downloadFile: function (key) {

            let rfc = this.$local_storage.get("rfc");
            let file = rfc + "/" + key + ".pdf";
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            var datos = {
                id: file,
                bucket: "production.econnect.ds",
            };
            axios
                .post(this.$hostname + "s3/download_url/", datos)
                .then((res) => {
                    if (typeof res.data !== "undefined") {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        a.click();
                        a.parentNode.removeChild(a);
                    } else {
                        this.$swal({
                            type: "info",
                            title: "¡Archivo no Localizado!",
                            text: "El archivo no se ha recuperado",
                            footer: "",
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (
                        error.response != undefined &&
                        error.response.data != undefined &&
                        error.response.data.mensaje != undefined
                    )
                        mensaje = error.response.data.mensaje;
                     this.$swal({
                            type: "info",
                            title: "¡Archivo no Localizado!",
                            text: "El archivo no se ha recuperado",
                            footer: mensaje,
                        });
                    console.log(error);
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
    }
}
</script>

<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
    color: black;
    font-size: small;
    background-color: #eeeeee;
    padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
    color: white;
    font-size: small;
    background-color: #df7205;
    padding: 0px;
    font-weight: bold;
}

.v-tabs-slider-wrapper {
    left: 0 !important;
}
.elevation-1 >>>  #VueTables_th--tipo {
        width: 105px !important;
    }

.elevation-1 >>> .columnaTipo {
  white-space: normal !important;
  max-width: 750px !important;
  min-width: 550px !important;
  text-align: justify !important;
}

#oculta_resumen >>> .VuePagination {
    display: none !important;
}

* {
    line-height: 1 !important;
    margin: 0 !important;
    padding: 0 !important;
}

</style>
<style scoped>
.VuePagination {
    display: none !important;
}
.headline2{
    text-transform: uppercase;
    font-weight: bold;
    line-height: 1.5 !important;
    font-size: 12px;
    color:navy;


}
</style>